import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommentCardComponent } from '@app/shared/components/comment/comment-card/comment-card.component';
import { FormattingDataService } from '@app/core/services/formatting-data/formatting-data.service';
import { FpLoggerNoiseCommentsStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-comments/services/fp-logger-noise-comments/fp-logger-noise-comments.store';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FloatingPopupService } from '@app/main/main-content/floating-popup-manager/services/floating-popup.service';
import { CommentCardNoDataComponent } from '@app/shared/components/comment/comment-card-no-data/comment-card-no-data.component';
import { PermissionName } from '@app/core/permissions/enums/permission-name.enum';

@Component({
  selector: 'gc-fp-logger-noise-comments-minimized',
  standalone: true,
  imports: [CommentCardComponent, CommentCardNoDataComponent],
  templateUrl: './fp-logger-noise-comments-minimized.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FpLoggerNoiseCommentsMinimizedComponent {
  public readonly currentTabStore = inject(FpLoggerNoiseCommentsStore);
  protected readonly formattingData = inject(FormattingDataService);
  protected readonly floatingPopupService = inject(FloatingPopupService);

  protected readonly PermissionName = PermissionName;

  public popup = input<IFloatingPopupInstance>();

  public readonly comment = toSignal(this.currentTabStore.comment$, {
    initialValue: null,
  });

  public readonly authorName = computed<string>(
    () => this.comment()?.author || this.formattingData.NO_DATA_VALUE_PLACEHOLDER_KEY
  );

  public readonly authorDate = computed<string>(() => this.formattingData.formatDate(this.comment()?.modifiedAt));

  public readonly message = computed<string>(
    () => this.comment()?.content || this.formattingData.NO_DATA_VALUE_PLACEHOLDER_KEY
  );

  public openPopup() {
    const popup = this.popup();

    if (popup) {
      if (popup.isMinimized) {
        this.floatingPopupService.maximize(popup.id);
      }
    }
  }
}
